/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type evidenceDetailsActionsQueryVariables = {
    id: string;
};
export type evidenceDetailsActionsQueryResponse = {
    readonly folder: {
        readonly id?: string | undefined;
        readonly name?: string | undefined;
        readonly type?: string | undefined;
    } | null;
};
export type evidenceDetailsActionsQuery = {
    readonly response: evidenceDetailsActionsQueryResponse;
    readonly variables: evidenceDetailsActionsQueryVariables;
};



/*
query evidenceDetailsActionsQuery(
  $id: ID!
) {
  folder: node(id: $id) {
    __typename
    ... on Folder {
      __isFolder: __typename
      id
      name
      type: __typename
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": "type",
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "evidenceDetailsActionsQuery",
    "selections": [
      {
        "alias": "folder",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "type": "Folder",
            "abstractKey": "__isFolder"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "evidenceDetailsActionsQuery",
    "selections": [
      {
        "alias": "folder",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "type": "Folder",
            "abstractKey": "__isFolder"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b127927690c507e74209605e18de4d1a",
    "id": null,
    "metadata": {},
    "name": "evidenceDetailsActionsQuery",
    "operationKind": "query",
    "text": "query evidenceDetailsActionsQuery(\n  $id: ID!\n) {\n  folder: node(id: $id) {\n    __typename\n    ... on Folder {\n      __isFolder: __typename\n      id\n      name\n      type: __typename\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '12eb54f7313469ae291aef5054b97926';
export default node;
